import { LAYOUT_OPTIONS } from "@/config/enums";
import { useLayout } from "@/layouts/use-layout";
import cn from "@/utils/class-names";
import JobFeed from "./job-feed";
import { JobFilters } from "./job-feed-filter";
import JobFeedHeader from "./job-feed-header";

export default function JobFeedTemplate() {
    let { layout } = useLayout();
    return (
        <div className="@container">
            <JobFeedHeader />
            <div
                className={cn(
                    "grid grid-cols-12 gap-x-6",
                    layout === LAYOUT_OPTIONS.LITHIUM &&
                        "mx-auto max-w-[1400px]",
                )}
            >
                <JobFeed className="col-span-full @4xl:col-span-8 @6xl:col-span-9" />
                <div className="col-span-4 hidden @4xl:grid @6xl:col-span-3">
                    <JobFilters />
                </div>
            </div>
        </div>
    );
}
